import { media } from "src/styles/mixins";
import theme from "src/styles/theme";
import styled, { css } from "styled-components";

export const SwitchContainer = styled.div`
  position: relative;
  width: 48px;
  height: 24px;
  background-color: ${theme.colors.background};
  border-radius: 32px;

  ${media.up("MOBILE")`
    width: 64px;
    height: 32px;
  `}
`;

export const SwitchInput = styled.input`
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  margin: 0;
  cursor: pointer;
`;

export const SwitchFakeCheckbox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  border-radius: 32px;
  overflow: hidden;
`;

export const SwitchBorder = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 32px;
  border: ${`${theme.border.thin} solid ${theme.colors.primary}`};
`;

export const SwitchBackground = styled.div<{ isActive: boolean }>`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  right: 100%;
  background-color: ${theme.colors.buttonSecondary};
  transition: transform 0.2s ease-out;

  ${({ isActive }) =>
    isActive &&
    css`
      transform: translateX(100%);
    `}
`;

export const SwitchCircle = styled.div<{ isActive: boolean }>`
  position: absolute;
  height: 24px;
  width: 24px;
  top: 0;
  left: 0;
  background-color: ${theme.colors.background};
  border: var(--border-thin) solid ${theme.colors.primary};
  border-radius: 32px;
  transition: transform 0.2s ease-out;
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.up("MOBILE")`
    height: 32px;
    width: 32px;
  `}

  ${({ isActive }) =>
    isActive &&
    css`
      transform: translateX(100%);
    `}
`;
